import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { modal } from "./ModalService";

export default function ModalProvider({ children }) {
  const [state, setState] = useState(null); // {type, title, message, ... , _resolve}
  const lastActive = useRef(null);

  useEffect(() => {
    // 구독
    const unsub = modal._subscribe((type, payload) => {
      if (type === "open") {
        lastActive.current = document.activeElement;
        setState(payload);
      } else if (type === "close") {
        close(payload);
      }
    });
    return unsub;
  }, []);

  function close(result) {
    if (!state) return;
    state._resolve?.(result);
    setState(null);
    // 포커스 복귀
    setTimeout(() => lastActive.current?.focus?.(), 0);
  }

  // ESC 닫기
  useEffect(() => {
    if (!state) return;
    const onKey = (e) => {
      if (e.key === "Escape") close(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [state]);

  return (
    <>
      {children}
      {state &&
        createPortal(
          <div
            className="ghm-ov"
            role="presentation"
            // onClick={() => state.backdropClose !== false && close(false)}
          >
            <div
              role="dialog"
              aria-modal="true"
              className="ghm-card"
              onClick={(e) => e.stopPropagation()}
            >
              {/* 헤더 */}
              <div className="ghm-head">
                <img
                  alt="logo"
                  src={require("../img/granhand_logo.png")}
                  className="ghm-brand"
                />
                <button
                  className="ghm-x"
                  aria-label="닫기"
                  onClick={() => close(false)}
                >
                  ×
                </button>
              </div>

              {/* 본문 */}
              <div className="ghm-body">
                {state.title && <h3 className="ghm-title">{state.title}</h3>}
                {state.message && <p className="ghm-msg">{state.message}</p>}
                {state.type === "custom" &&
                  typeof state.render === "function" &&
                  state.render(close)}
              </div>

              {/* 푸터(버튼) */}
              {(state.type === "confirm" || state.type === "alert") && (
                <div className="ghm-actions">
                  {state.type === "confirm" && (
                    <button
                      className="ghm-btn ghm-btn--ghost"
                      onClick={() => close(false)}
                    >
                      {state.cancelText || "취소"}
                    </button>
                  )}
                  <button
                    className="ghm-btn ghm-btn--primary"
                    onClick={() => close(true)}
                  >
                    {state.okText || "확인"}
                  </button>
                </div>
              )}
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
